import { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { FarmInputsTab } from './FarmInputsTab';
import { EquipmentTab } from './EquipmentTab';

export const InventoryPage = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" mb={3}>Inventory</Typography>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
        <Tab label="Farm Inputs" />
        <Tab label="Equipment" />
      </Tabs>
      {tab === 0 && <FarmInputsTab />}
      {tab === 1 && <EquipmentTab />}
    </Box>
  );
};
